export const locale = {
    lang: 'zh1',
    data: {
      'PRINCIPAL': {
        'TITULO': '調查狀態',
        'SUBTITULO': '您可以查看和跟進公司一項或多項產品所申請的調查信息',
        'COPY_URL_RES':'從 SuccesGo 複製 URL',
      },
      'MENU_PRODUCTOS': {
        'TITULO': '購買的產品',
        'CARGANDO': '正在加載產品列表',
        'NOMBREPULSO': '脈衝',
        'TIPOS': {
          'certificar': {
            'NOMBRE': '證明',
            'SUBTIPOS': {
              'v1': '認證 v1',
              'v2': '認證 v2.0',
              'v3': '認證 v3.0',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': '附加認證',
            'SUBTIPOS': {
              'v1Amco': '安科',
              'v2TD': '體面的工作',
              'v3PE': '第一份工作',
            }
          },
          'medir': {
            'NOMBRE': '措施',
            'SUBTIPOS': {
              'v1': '測量 v1',
              'v2': '措施改進',
              'v3': '測量 + MST',
              'v4': '按面積測量',
              'v5': '領導衡量',
              'v6': '按尺寸測量',
              'v7': '措施證明',
              'v8': '測量 3.0',
            }
          },
          'pulse': {
            'NOMBRE': '按檢查',
            'SUBTIPOS': {
              'v1': '脈搏檢查 v1.0',
              'v2': '脈搏檢查 v3.0',
            }
          },
          'focus': {
            'NOMBRE': '重點地區',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': '文化快車',
            'SUBTIPOS': {
              'cgoExpress': '文化快車'
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow 結果',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow 結果'
            }
          },
        }
      },
      'DETALLES': {
        'TITULO': '產品詳情',
        'PRODUCTO': '產品：',
        'PROGRESO': '進步',
        'RESTANTE': '剩餘時間',
        'DIASREST': '剩余天數：',
        'PANELFIJO': '顯示為固定面板',
        'SURVEYTOKEN': '調查令牌',
        'ACCOUNT_ID': '帳戶ID',
        'OPORTUNITY_ID': '機會 ID',
        'FECHAS': {
          'lanzamiento': '發布日期',
          'cierre': '最後期限',
          'prorroga': '延期日期',
          'recordatorio':'提醒事項',
          'avisos':'調查前溝通',
        },
        'AVANCES': {
          'NORMAL': '提前回复：',
          'MAS50': '超過 50 歲：',
          'MAS50_2': '超過 50 - 預先回答',
          'MENOS50': '50以下的預付款：',
          'MENOS50_2': '少於 50 - 提前回复'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': '選擇產品',
          'VERPROD_2': '查看其他產品',
          'OCULTAR': '隱藏'
        },
        'PREVIA': {
          'TITULO': '按產品分類的調查狀態',
          'SUBTITULO': '該公司購買的產品列表顯示在此屏幕左側的菜單中。要查看每個產品的調查狀態，請單擊產品類別，然後選擇年份。在此之後，將顯示所選調查的詳細信息，僅當所選產品已有初始化調查時',
          'CARGANDO': '正在檢索所選產品的狀態，請稍候'
        },
        'ESTADOS': {
          'NOCREADA': '此產品尚未創建調查',
          'NOINICIADA': '未啟用調查'
        },
      },
      'COLABORADORES': {
        'TAB': '合作者名單',
        'CARGANDO': '正在加載合作者列表',
        'TABLA': {
          'TITULO': '合作者名單',
          'NOINFO': '無信息',
          'COLUMNAS': {
            'NOMBRE': '全名',
            'EMAIL': '電子郵件',
            'PASS': '密碼',
            'STATUS': '實際狀態',
            'FECHA_INI': '開始日期',
            'FECHA_FIN': '完成日期',
            'ACCIONES': '行動'
          },
          'TOOLTIPS': {
            'ACCIONES': '可用操作',
            'EMAILS': '電子郵件日誌',
          },
        },
        'ACCIONES': {
          'TITULO': '可用操作',
          'LISTA': {
            'primerosColab': '查看前 1000 個',
            'buscarColab': '尋找合作者',
            'nuevoColab': '添加新的合作者',
            'enviaReco': '發送提醒',
            'bajarColab': '下載合作者名單',
          }
        },
        'SENDGRID': {
          'TITULO': '發送郵件日誌',
          'SUBTITULO': '從列表中選擇主題類型以顯示已發送電子郵件的歷史記錄',
          'SELOPC': '選擇一個選項',
          'INFOASUNTO': {
            'TITULO': '郵件信息',
            'CARD': {
              'from': '發給',
              'to': '從',
              'subject': '郵件主題'
            },
            'HISTORIAL': {
              'TITULO': '電子郵件提交歷史',
              'SUBTITULO': '注意：列表中顯示的日期/時間設置為當地時間',
              'VECESABIERTO': '營業時間',
              'ULTIMOEVENTO': '上次活動',
              'NORECORDS': '您的電子郵件歷史記錄不可用',
              'STATUS': {
                'ABIERTO': '郵件已發送',
                'NOENVIADO': '尚未發送'
              }
            }
          },
          'BOTONES': {
            'BACK': '回去'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': '可用操作',
          'SUBTITULO': '以下列表顯示了用戶可用的操作列表',
          'CARGANDO': '加載可用操作',
          'LISTA': {
            'modificar': '修改選定協作者的數據',
            'borrar': '刪除選定的協作者',
            'invitacion': '重新發送邀請',
            'recordatorio': '重新發送提醒',
            'respuestas': '刪除調查回复',
            'resetSur': '重置調查訪問權限',
          }
        },
        'MODALES': {
          'BUSCAR': '輸入協作者姓名進行搜索',
          'BUSCAR_BOT': '搜索',
          'MINIMARECO': '提醒只能從調查開始之日起發送',
          'GENERAEXCEL': '生成協作者的excel文件，稍等',
          'NOANSWERS': '沒有找到該參與者的回复',
          'ENVIOCORREO': '正在發送消息，請稍等',
          'BORRARESP': '正在刪除該用戶的回复，請稍等',
        },
        'EXCEL': {
          'TITUARCHIVO': '合作者名單',
          'COLUMNAS': {
            'name': '合作者姓名',
            'email': '電子郵件',
            'id_status': '調查狀態',
            'start_date': '開始日期',
            'end_date': '完成日期',
          }
        }
      },
      'ACCIONES': {
        'TAB': '行動',
        'TITULO': '按類別可用的操作列表',
        'CATEGORIAS': {
          'encuesta': '民意調查',
          'filemanager': '文件管理器',
          'resultados': '结果',
          'webcompro': '網站上的公司簡介',
        },
        'LISTA': {
          'surveyCheck': '檢查調查',
          'surveyDown': '下載調查',
          'goSurvey': '去調查',
          'goCounting': '轉到計數門戶',
          'goCounting_more50': '前往計數門戶 +50',
          'goCounting_less50': '前往計數門戶 -50',
          'genCountingUrl': '生成到 Counts Portal 的外部鏈接',
          'copyCountingUrl': '將外部鏈接複製到 Counts 門戶',
          'updateCounting': '與 Counts 門戶同步',
          'addPro': '添加擴展',
          'verRecord': '記錄的提醒',
          'surveyClose': '近距離調查',
          'surveyOpen': '公開調查',
          'processRes': '處理結果',
          'goPriv': '查看私人文件夾',
          'goPub': '查看公用文件夾',
          'verRes': '查看结果',
          'upNameIcon': '更新名稱和徽標',
          'regCertifi': '重新生成證書',
          'goSurveyMas50': '轉到調查 +50',
          'goSurveyMenos50': '轉到調查 -50',
          'auditMan': '人工審核',
          'libeCultureBrief': '文化簡報發布',
          'lockRes': '鎖定結果',
          'verCultureAudit': '見文化審計',
          'verAvisos':'調查前溝通',
          'enviaCorreos': '手動發送電子郵件',
          'verWebComPro': '在網絡上查看公司簡介',
          'verFechIniCie': '開始/結束日期',
          'cancelarEnvios': '取消發送電子郵件',
          'verConfigResult': '結果配置',
          'descaDemo': '允許下載人口統計數據',
          'crearClave':'生成外部公司資料的密鑰',
          'copyClave':'將密鑰複製到外部公司資料',
          'verDatWPC':'查看外部公司資料訪問數據',
          'confirReviCultureAudit':'確認文化審核審核',
          'cambiaCultureBrief': '文化審核簡介產品鏈接'
        },
        'MODALES': {
          'URL': '鏈接已復製到剪貼板',
          'URL_CLA': '密鑰已復製到剪貼板',
          'CHANGE_RESULT':'加载结果',
          'LOADINGMASTER': '正在從主表中檢索信息，請稍等',
          'CONFIR_UPDA_NAM':'您確定要更新名稱和徽標嗎？',
          'CONFIR_REG_CERT':'您確定要重新生成證書嗎？',
          'SUCC_UPDA_NAME':'成功更新',
          'UPDA_NAME_ICON':'更新數據',
          'UPDA_STA_ENC':'更新調查狀態',
          'OBT_DAT_AUD_AUT':'獲取審計信息',
          'WARNI_NOT_EXIT_TOKEN':'錯誤：令牌在 MT 中不存在',
          'CONFIR_REPRO_RESULT':'你確定要重新處理結果嗎？',
           'MOD_INGRE_COD_PT1':'<span> 確認，在文本框中輸入紅色代碼',
           'MOD_INGRE_COD_PT2':'</span>',
           'ERROR_CODIGO': '輸入的代碼與紅色標示的不匹配',
           'CONFIR_LIBE_CULT_BRI':'你確定要發布文化簡介嗎？',
           'CONFIR_REVI_CULT_AUDIT':'您確定確認文化審核審核嗎？',
           'NO_CONFIR_REVI_CULT_AUDIT':'確定取消文化審核審核？',
           'NO_CULT_BRI_ASOC':'沒有發現相關的文化審計',
           'BLOQUEAR_1_1': '結果當前已解鎖\n是否要鎖定結果？',
           'BLOQUEAR_1_2': '輸入結果被屏蔽的原因',
           'BLOQUEAR_2_1': '結果當前已鎖定\n是否要解鎖結果？',
           'BLOQUEAR_2_2': '寫出結果被解鎖的原因',
           'BLOQUEAR_3_1': '有必要說明更改的原因',
           'SINCRONIZARMT': '主表數據正在同步中，請稍等',
           'UPDA_DAT_RECOR': '更新提醒日期',
           'DELE_DAT_RECOR': '刪除提醒日期',
           'UPDA_DAT_AVI': '通知日期更新',
           'DELE_DAT_AVI': '取消通知日期',
           'CANCELAR_ENVIOS': '您確定要取消預定的電子郵件嗎？',
           'CANCELAR_ENVIOS_OK': '貨件已成功取消。',
           'CANCELAR_ENVIOS_ERROR': '調查開始前兩小時內無法取消配送。',
           'COM_CRE_ACCE_WCP_EXT': '您確定要為公司資料創建密鑰嗎？',
           'CRE_ACCE_WCP_EXT': '生成密碼',
           'SUCC_CRE_ACCE_WCP_EXT': '密碼生成成功',
           'TIT_MOD_VALI_ACCE_WCP_EXT': '繼續：輸入您的密碼',
           'PLA1_MOD_VALI_ACCE_WCP_EXT': '您目前還剩 ',
           'PLA2_MOD_VALI_ACCE_WCP_EXT': ' 嘗試',
           'BTN_ACEP': '接受',
           'BTN_CAN': '取消',
           'WAR_ACCE_WCP_EXT': '輸入的密碼不正確',
           'LIMI_ACCE_WCP_EXT': '您已達到嘗試次數上限',
           'DESAC_ACCE_WCP_EXT': '您的公司資料目前已停用',
           'ACTU_ACCE_WCP_EXT': '更新信息',
           'SUCC_ACTU_ACCE_ACCE_WCP_EXT': '更新成功',
           'CHANGE_WCP':'加載公司簡介',
        },
        'SUBACCIONES': {
          'TITULO': '單擊此處查看更多可用操作',
          'AUDMANUAL': {
            'TITULO': '人工審核',
            'NOMBRE': '審核員姓名',
            'NOTAS': '觀察',
            'STATUS': {
              'ON': '接受審核',
              'OFF': '審核被拒絕'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': '更改結果版本類型',
              'MODAL': {
                'TITULO': '版本類型選擇',
                'SUBTITULO': '選擇此產品的結果版本類型',
                'SINCERT': '無證書版本',
                'CONCERT': '帶證書的版本'
              }
            },
            'tipoResuV2': {
              'TITULO': '查看結果版本 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': '更改證書徽標',
            },
            'previewCert': {
              'TITULO': '證書預覽',
            },
            'multiSite': {
              'TITULO': '啟用多站點證書文本',
            },
            'multiSiteText': {
              'TITULO': '查看多站點證書文本',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': '更改公司標誌'
            },
            'previewLogoEmp': {
              'TITULO': '標誌預覽'
            },
            'updateDatCerti': {
              'TITULO': '更改證書日期',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': '同步主表'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': '狀態見外部公司簡介',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': '狀態見外部公司簡介',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': '狀態見網站上的公司簡介',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'民眾',
              'ESTA_WPC_NPU':'非公開',
            },
          },
          'cambiaCultureBrief': {
            'TITULO': '文化審核簡介產品鏈接',
            'STATUS_SIN': '目前該產品沒有鏈接的文化審計簡報產品',
            'STATUS_CON': '目前已鏈接的產品',
            'BOTON_ELEGIR': '鏈接產品文化審核簡介',
            'BOTON_ELEGIR_2': '確認',
            'BOTON_CAMBIAR': '與另一個產品鏈接文化審計簡介',
            'LISTA_ELEGIR': '從列表中選擇文化簡介產品',
            'LISTA_DISPONIBLES': '可用產品',
            'SIN_OPCIONES': '沒有可用的產品',
            'MESSAGE3': '<span>要確認所選的 Culture Audit Brief 產品鏈接，請在文本框中輸入紅色文本：',
            'MESSAGE4': '</span>',
            'MESSAGE5': '所選的 Culture Audit Brief 產品已成功鏈接到您的 Certify 產品',
            'VALIDAR': '確認',
            'SALIR': '取消',
            'ERRORNOMBREEMPRESA': '輸入的文本與紅色指示的文本不匹配',
            'CERRAR': '關閉',
          }
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': '已發送電子郵件的歷史記錄',
        'TITULO': '為該產品發送的電子郵件列表',
        'TABLA': {
          'DESTINATARIO': '收件人',
          'ASUNTO': '郵件主題',
          'ESTADO': '當前狀態',
          'VECES': '打開次數',
          'ULTIMO': '上次活動的日期',
          'FILTRO': '篩選',
          'INPUT_DEST': '按電子郵件地址過濾',
          'INPUT_ASU': '按主題過濾',
          'INPUT_STAT': '按狀態過濾',
          'ELIJAOPCION': '- 從列表中選擇一個選項 -',
          'NORESULTS': '沒有找到記錄',
          'LISTA_STATUS': {
            'delivered': '發送',
            'processed': '發貨過程中',
            'not_delivered': '未發送'
          }
        },
        'ACCIONES': {
          'TITULO': '可用操作',
          'LISTA': {
            'enviaCorreos': '手動發送電子郵件',
            'getEnviados': '更新電子郵件發送歷史',
          }
        },
        'MODAL': {
          'TITULO': '手工郵寄',
          'SUBTITULO': '您可以立即向此調查中的合作者發送特定類型的手動郵件',
          'INPUT': '選擇郵件類型',
          'TIPOS': {
            '1': '邀請郵件',
            '2': '提醒郵件',
            '3': '開始調查前的第一通知',
            '4': '調查開始前的第二次通知',
            '5': '關閉郵件',
            '6': '發送給尚未開始調查的合作者的郵件',
            '7': '發送給已開始但尚未完成的協作者的郵件'
          },
          'BOTONES': {
            'BACK': '回去',
            'CONTINUAR': '繼續',
            'SAVE': '保存審核',
          }
        },
        'MODALES': {
          'RECUPERANDO': '正在檢索已發送郵件列表，請稍等',
          'SEND_EMA':'發送郵件',
          'SUCC_SEND_EMA':'郵件發送成功',
          'CONFIRMAR': '您是否確認向本次調查中的合作者發送所選類型的電子郵件？',
          'ENVIADOS': '郵件已成功發送，請盡快更新歷史記錄以查看已發送的郵件',
          'SI': '是的',
          'NO': '不',
          'UPDAT_HIST_EMA': '更新歷史',
          'SUCC_UPDAT_HIST_EMA': '更新成功',
          'WAR_SEL_MAI': '要繼續，請選擇郵件類型',
          'WAR_SQL_ERROR': '回复時間已過，請重試',
        },
        'RESUMEN': {
          'TITULO': '概括',
          'TIPOS': {
            'totalEnviados': '開始的郵件總數',
            'delivered': '正確郵寄',
            'processed': '正在處理的郵件',
            'not_delivered': '未發郵件',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'調查審核',
        'TEX_AUDI_NOT_AUTORI': '審核被拒絕！',
        'TEX_AUDI_YE_AUTORI':'審核通過！',
        'TITL_AUDI_DEV_TR':'% Dev.Time 響應',
        'TITL_AUDI_DEV_PC':'% 開發。 問題控制',
        'TITL_AUDI_DEV_PA':'% 開發。 問題隨機',
        'TIT_PAGI_TABL':'每頁文章',
        'COLUMNAS':{
          'HierarchicalPath':'結構',
          'RespondentCount':'# 回复',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.控制',
          'ControlStatement_DeviationPercentage':'% Desv P.控制',
          'RandomStatement_DeviationPercentage':'# Desv P.隨機的',
          'RandomStatement_DeviationCount':'% Desv P.隨機的',

        }
      },
      'EMAI_LOG':{
        'TAB':'一般郵件歷史',
         'TABLA_GLOBAL':{
           'TITU':'全局顯示',
           'SUB_TIT':'總貢獻者',
           'TH_1':'狀態',
           'TH_2':'第一個通知',
           'TH_3':'第二次通知',
           'TH_4':'邀請',
           'TH_5':'提醒未開始的用戶',
           'TH_6':'提醒未完成的用戶',
           'enviados':'已發送',
           'procesando':'處理',
           'error':'錯誤',
           'VIE_DETA_TOOL':'查看詳情',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': '顯示已發送警告 1 類郵件',
          'TITU_AV1_PROCC':'正在顯示郵件類型通知 1',
          'TITU_AV1_N_DELIV':'錯誤顯示郵件警告1的類型',

          'TITU_AV2_DELIV': '顯示類型的郵件警告 2 發送',
          'TITU_AV2_N_DELIV':'錯誤顯示郵件警告2的類型',
          'TITU_AV2_PROCC': '顯示類型 2 通知 2 正在處理的郵件',

          'TITU_INV_DELIV':'發送郵件邀請的顯示類型',
          'TITU_INV_PROCC': '顯示正在處理的邀請郵件類型',
          'TITU_INV_N_DELIV': '顯示邀請郵件類型錯誤',

          'TITU_REC1_DELIV':'顯示已發送的提醒郵件類型 1',
          'TITU_REC1_PROCC':'顯示正在處理的提醒郵件類型 1',
          'TITU_REC1_N_DELIV':'顯示提醒1郵件類型錯誤',

          'TITU_REC2_DELIV':'顯示已發送的提醒郵件類型 2',
          'TITU_REC2_N_DELIV':'顯示錯誤提示郵件類型 2',
          'TITU_REC2_PROCC': '顯示正在處理的提醒郵件類型 2',
          'SUB_TIT':'合作者總數',
          'TH_1':'狀態',
          'TH_2':'貢獻者姓名',
          'TH_3':'消息',
          'TH_4':'上一封電子郵件的日期',
          'TH_5':'郵件總數',
          'TH_6':'動作',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'輸入姓名或電子郵件',

         },
         'TEX_MOD_CHA_INFO':'加載信息',
        'CONT_MOD':{
          'TAB_TIT1':'郵件狀態',
           'TAB_TIT2':'郵件視圖',
           'TEX_CHA_INFO_GRAL':'加載信息',
           'TEX_ASUN':'主題：',
           'TEX_SELEC_EMA':'選擇一個電子郵件',
           'TEX_CHA_INFO_EMA':'正在加載郵件信息',
           'H1_TIT_EMA_INFO':'電子郵件信息',
           'SPAN_SUB_TIT_DET':'詳細信息',
           'TO':'至:',
           'FROM':'發件人:',
           'SUBJE':'主題',
           'MESS_ID':'消息ID：',
           'BTN_VER_MAS':'更多詳情',
           'BTN_VER_MEN':'細節較少',
           'TIT_TEX_LIS':'事件歷史',
           'SPAN_RECIV_SENGR':'由 SendGrid 接收',
           'SPAN_RECIV_FROM':'收到',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'收件人打開了這封郵件',
          'REASON':{
           'Bounced Address':'彈回地址',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD':'修改證書日期',
         'ING_DAT':'選擇日期：',
         'ING_RAS':'輸入修改日期的原因：',
         'BTN_SAV':'保存更改',
         'BTN_OK':'好的',
         'MOD_ING_REA':'輸入日期更改的原因',
         'MOD_UPD_DAT':'更新證書日期',
         'SUCC_MOD_UPD_DAT':'更新成功',

      },
      'DAT_STAEND':{
        'TIT_MOD':'調查開始和結束日期',
         'SUB_TIT_MOD':'每個日期以當地時間顯示在',
         'TEX_DA_STA':'開始日期',
         'TEX_DA_EN':'結束日期',
         'MOD_UPD_DA_DA_STA':'更新發布日期',
         'MOD_UPD_DA_EN':'更新結束日期',
         'SUCC_MOD_UPD_DA_DA_STA':'更新成功',
         'SUCC_MOD_UPD_DA_DA_EN':'更新成功',

      },
      'LANG_CERT':{
        'TIT_MOD':'選擇語言：',
      },
    }
};
